export default __webpack_public_path__ + "maps-examples-approximate-location-thumbnail-480-3908529226c2e7175efce2e1a52ad409.png";